export enum PurchaseType {
    TICKET = 'ticket',
    SEASON_PASS = 'season_pass',
    FLEX = 'flex',
}